module.exports = __webpack_public_path__ + "assets/img/modal-no-backdrop@2x.png";